import * as React from 'react'
import { CookieBanner } from './CookieBanner'
import { Router, Route, Switch } from 'react-router-dom'
import browserHistory from 'common/browserHistory'

export const CookieBannerContainer: React.FC = () => {
  return (
    <Router history={browserHistory}>
      <Switch>
        <Route path="/:locale/impressum">
          <CookieBanner shouldShowImprint={false} />
        </Route>
        <Route path="/:locale/privacy-notice">
          <CookieBanner shouldShowPrivacyNotice={false} />
        </Route>
        <Route>
          <CookieBanner shouldShowPrivacyNotice={true} />
        </Route>
      </Switch>
    </Router>
  )
}
